<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Requester"
      @click.native.stop
    >
      <v-select
        v-model="dutyOfficerValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select from list"
        :options="dutyOfficerOptions"
        :clearable="false"
        :reduce="name => name._id"
      />
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group
      label="Service Form"
      @click.native.stop
    >
      <v-select
        v-model="serviceFormValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="stringID"
        multiple
        placeholder="Select from list"
        :options="serviceFormOptions"
        :clearable="false"
        :reduce="opt => opt._id"
      />
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <b-form-group
      label="Store"
      @click.native.stop
    >
      <v-select
        v-model="storeValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select from list"
        :options="storeOptions"
        :clearable="false"
        :reduce="opt => opt._id"
      />
    </b-form-group>
    <hr class="dividerHR filter-divider">
    <div v-if="$route.params.type == 'all-requests'">
      <b-form-group label="Status">
        <b-form-checkbox
          v-for="option in statusOptions"
          :key="option.value"
          v-model="statusFilterValue"
          :value="option.value"
          name="flavour-3a"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-form-group>
      <hr class="dividerHR filter-divider">
    </div>
    <b-form-group
      label="Service Date"
    >
      <b-input-group>
        <flat-pickr
          v-model="serviceDateFilterValue"
          class="form-control"
          placeholder="Select Date Range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-button
      variant="outline-primary"
      size="sm"
      class="mr-1"
      @click="clearFilter"
    >
      Clear All
    </b-button>
    <b-button
      variant="primary"
      size="sm"
      @click="applyFilter"
    >
      Apply Filter
    </b-button>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    vSelect,
    flatPickr,
  },
  props: {
    statusFilter: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    serviceDateFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    dutyOfficer: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    dutyOfficerOptions: {
      type: Array,
      required: true,
    },
    serviceForm: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    serviceFormOptions: {
      type: Array,
      required: true,
    },
    store: {
      type: [Array, null],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [],
    },
    storeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      serviceDateFilterValue: this.serviceDateFilter,
      statusFilterValue: JSON.parse(JSON.stringify(this.statusFilter)) || [],
      dutyOfficerValue: JSON.parse(JSON.stringify(this.dutyOfficer)) || [],
      serviceFormValue: JSON.parse(JSON.stringify(this.serviceForm)) || [],
      storeValue: JSON.parse(JSON.stringify(this.store)) || [],
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    serviceDateFilter: {
      immediate: true,
      handler(val) {
        this.serviceDateFilterValue = val
      },
    },
    statusFilter: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    dutyOfficer: {
      immediate: true,
      handler(val) {
        this.dutyOfficerValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    store: {
      immediate: true,
      handler(val) {
        this.storeValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    serviceForm: {
      immediate: true,
      handler(val) {
        this.serviceFormValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:serviceDate', this.serviceDateFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:dutyOfficer', this.dutyOfficerValue)
      this.$emit('update:serviceForm', this.serviceFormValue)
      this.$emit('update:store', this.storeValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.serviceDateFilterValue = ''
      this.statusFilterValue = []
      this.dutyOfficerValue = []
      this.storeValue = []
      this.serviceFormValue = []
      this.$emit('update:serviceDate', this.serviceDateFilterValue)
      this.$emit('update:statusFilter', this.statusFilterValue)
      this.$emit('update:dutyOfficer', this.dutyOfficerValue)
      this.$emit('update:serviceForm', this.serviceFormValue)
      this.$emit('update:store', this.storeValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
